import { Alert, Grid, List, Stack, Switch, Text, TextInput } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const looksLikeFullUrl = (value) => {
  const v = (value || '').trim().toLowerCase();
  return v.includes('://') || v.startsWith('www.');
};

const URLFilterConfig = ({ labelCol, selectorCol, modelInstance, modelName, handleChange }) => {
  const { domain } = useSelector((state) => state.domain);
  const exampleBase = (domain.url || '').replace(/\/$/, '');
  const [showFilters, setShowFilters] = useState(!!modelInstance.urlRegex || !!modelInstance.urlRegexNoMatch);
  const [showUrlContainsHint, setShowUrlContainsHint] = useState(!!modelInstance.urlRegex);
  const [showUrlDoesNotContainHint, setShowUrlDoesNotContainHint] = useState(!!modelInstance.urlRegexNoMatch);

  const handleShowUrlHintText = (e, isUrlContains) => {
    const isNotEmpty = e.target.value.trim() !== '';
    if (isUrlContains) {
      setShowUrlContainsHint(isNotEmpty);
    } else {
      setShowUrlDoesNotContainHint(isNotEmpty);
    }
    return isNotEmpty;
  };

  const fullUrlWarning = (
    <Text size="xs" c="orange.7">
      Looks like a full URL. Enter just the unique part (e.g. <strong>categories/footwear</strong>), not the whole{' '}
      <strong>https://</strong> link, or it will match more pages than you expect.
    </Text>
  );

  return (
    <Grid data-tour="urlFilterField">
      <Grid.Col span={labelCol}>
        <Text fw={500}>URL filter</Text>
      </Grid.Col>
      <Grid.Col span={selectorCol}>
        <Stack gap="xs">
          <Switch
            checked={showFilters}
            onChange={(e) => {
              handleChange({ target: { name: 'urlFilter', value: e.currentTarget.checked } });
              setShowFilters(e.currentTarget.checked);
            }}
          />
          {showFilters && (
            <>
              {showUrlContainsHint && (
                <Text size="sm" c="dimmed">
                  Show only where URL contains
                </Text>
              )}
              <TextInput
                name="urlRegex"
                value={modelInstance.urlRegex || ''}
                placeholder="URL contains"
                onChange={(e) => {
                  handleChange(e);
                  setShowUrlContainsHint(handleShowUrlHintText(e, true));
                }}
              />
              {looksLikeFullUrl(modelInstance.urlRegex) && fullUrlWarning}

              {showUrlDoesNotContainHint && (
                <Text size="sm" c="dimmed">
                  Hide where URL contains
                </Text>
              )}
              <TextInput
                name="urlRegexNoMatch"
                value={modelInstance.urlRegexNoMatch || ''}
                placeholder="URL doesn't contain"
                onChange={(e) => {
                  handleChange(e);
                  setShowUrlDoesNotContainHint(handleShowUrlHintText(e, false));
                }}
              />
              {looksLikeFullUrl(modelInstance.urlRegexNoMatch) && fullUrlWarning}

              <Alert
                variant="light"
                color="blue"
                title="Tip: match by path, not the full link"
                icon={<IconInfoCircle size={16} />}
                mb="md"
              >
                <Text size="sm">
                  Enter a word from the page address, e.g. <strong>footwear</strong> to target{' '}
                  <strong>{exampleBase}/categories/footwear</strong>.
                </Text>
                <List size="sm" spacing="xs" mt="xs">
                  <List.Item>
                    <Text span fw={600}>
                      URL contains
                    </Text>{' '}
                    - shows this {modelName} only on matching pages.
                  </List.Item>
                  <List.Item>
                    <Text span fw={600}>
                      URL doesn't contain
                    </Text>{' '}
                    - hides it on matching pages.
                  </List.Item>
                </List>
              </Alert>
            </>
          )}
        </Stack>
      </Grid.Col>
    </Grid>
  );
};

export default URLFilterConfig;
